export default __webpack_public_path__ + "static/media/about-team-yi-han.81e32d07.png";